import { memo, useEffect, useState, useCallback, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import ChatSideBar from '@/features/Chat/chat-side-bar'
import { select } from '@/store'
import { getParams } from '@/hooks/use-search-params'

const SideBar = memo(({ closeNav, isOpen, isTourRedirect }) => {
  const dispatch = useDispatch()
  const element = useRef()
  const location = useLocation()
  const isSearchOrFilter = location?.search && location?.search !== '?'
  const searchParams = getParams(location.search)
  const isSearch = !!searchParams.search
  const timelines = useSelector(isSearch ? select.chat.timelinesSearch : select.chat.timelines)
  const [loading, setLoading] = useState(false)
  const handleSearchPaginate = useCallback(async () => {
    const params = getParams(location.search)
    await dispatch.chat.loadMoreTimelinesSearch(params)
  }, [dispatch.chat, location.search])

  const getNextTimelines = (...args) => {
    return isSearchOrFilter
      ? handleSearchPaginate(...args)
      : dispatch.chat.getNextTimelines(...args)
  }

  useEffect(() => {
    if (isSearchOrFilter) return
    setLoading(true)
    const fetchTimelines = async () => {
      await dispatch.chat.getTimelines()
      setLoading(false)
      element?.current?.scrollTo(0, 0)
    }
    fetchTimelines()
  }, [dispatch.chat, isSearchOrFilter])

  useEffect(() => {
    if (!isSearchOrFilter) return
    setLoading(true)
    const fetchTimelines = async () => {
      const params = getParams(location.search)
      await dispatch.chat.getTimelinesQueryString(params)
      setLoading(false)
      element.current.scrollTo(0, 0)
    }
    fetchTimelines()
  }, [dispatch.chat, isSearchOrFilter, location.search])

  return (
    <ChatSideBar
      isOpen={isOpen}
      closeNav={closeNav}
      onEndReached={getNextTimelines}
      data={timelines}
      loading={loading}
      isTourRedirect={isTourRedirect}
      ref={element}
    />
  )
})

export default SideBar
